/* esm.sh - js-cookie@3.0.6 */
export * from "/*js-cookie@3.0.6/esnext/js-cookie.mjs";
export { default } from "/*js-cookie@3.0.6/esnext/js-cookie.mjs";
